import React from 'react'
import cx from 'classnames'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import { Grid, Cell } from 'components/_new/layout/grid'

import s from './Tabs.scss'
import messages from './messages'

import fragranceImage from './images/fragrance.svg'
import skincareImage from './images/skincare.svg'
import makeupImage from './images/makeup.svg'
import wellnessImage from './images/wellness.svg'


const products = [
  { title: messages.fragrance, image: fragranceImage },
  { title: messages.skincare,  image: skincareImage  },
  { title: messages.makeup,    image: makeupImage    },
  { title: messages.wellness,  image: wellnessImage  },
]


const Tabs = ({ selectedIndex, handleTabClick }) => (
  <Grid className={s.container} columns={4} gutter="12">
    {
      products.map(({ title, image }, index) => (
        <Cell
          key={index}
          className={cx({
            [s.active]: index === selectedIndex,
          })}
        >
          <div onClick={() => handleTabClick(index)}>
            <Box className={s.imageContainer} center>
              <img src={image} alt="" />
            </Box>
            <Box pt="8" alignCenter>
              <Text className={s.text} message={title} size="14-16" />
            </Box>
          </div>
        </Cell>
      ))
    }
  </Grid>
)


export default Tabs
